// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.background {
  height: 480px;
  background-position: center center;
  overflow: hidden;
  animation:fadeIn 2s forwards;
}

.homePage {
  animation:fadeIn 2s forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.homeTitleContainer {
  margin:0 auto;
  position: absolute;
  width: 80%;
  inset: 0;
  display:flex;
  align-items: center;
  justify-items: center;
  flex-direction: column;
  text-align: center;
}


.subtitleContainer {
  width: 50vw;
  display: flex;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  opacity:0;
  animation:fadeIn 2s forwards;
}
.homeSubtitleText {
  
  opacity:"0";
  animation:"fadeIn 2s forwards";
  text-align: center;
  font-size: 24pt;
  text-size-adjust: "8xl";
  color: black;
  font: "thin";
}

.mainContent {
  opacity:0;
  animation:fadeIn 2s forwards;
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.showcaseRow {
  width: auto;
  display: flex;
  align-items: center;
  flex-direction: row;
}

.showcaseItem {
  background-color: tomato;
  border-radius: 25px;
  height:100%;
  width: 45vw;
  padding: 5px;
  display:flex;
  margin: 10px;
  line-height: 20px;
  color: white;
  font-size: 2em;
  text-align: center;
  justify-content: center;
}

.showcaseItem img {
  background-position: center center;
  overflow: hidden;
  border-radius: 25px;
}

.showcaseText {
  height:100%;
  width: 45vw;
  padding: 5px;
  display:flex;
  margin: 10px;
  font-size: 20pt;
  text-align: center;
  justify-content: center;
}

hr {
  border: 1px solid #000;
  width:80vw;
  margin:10vh
}`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;AACA;;EAEE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV;AACF","sourcesContent":["\n.background {\n  height: 480px;\n  background-position: center center;\n  overflow: hidden;\n  animation:fadeIn 2s forwards;\n}\n\n.homePage {\n  animation:fadeIn 2s forwards;\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n  }\n}\n\n.homeTitleContainer {\n  margin:0 auto;\n  position: absolute;\n  width: 80%;\n  inset: 0;\n  display:flex;\n  align-items: center;\n  justify-items: center;\n  flex-direction: column;\n  text-align: center;\n}\n\n\n.subtitleContainer {\n  width: 50vw;\n  display: flex;\n  margin: 0 auto;\n  text-align: center;\n  align-items: center;\n  opacity:0;\n  animation:fadeIn 2s forwards;\n}\n.homeSubtitleText {\n  \n  opacity:\"0\";\n  animation:\"fadeIn 2s forwards\";\n  text-align: center;\n  font-size: 24pt;\n  text-size-adjust: \"8xl\";\n  color: black;\n  font: \"thin\";\n}\n\n.mainContent {\n  opacity:0;\n  animation:fadeIn 2s forwards;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.showcaseRow {\n  width: auto;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n.showcaseItem {\n  background-color: tomato;\n  border-radius: 25px;\n  height:100%;\n  width: 45vw;\n  padding: 5px;\n  display:flex;\n  margin: 10px;\n  line-height: 20px;\n  color: white;\n  font-size: 2em;\n  text-align: center;\n  justify-content: center;\n}\n\n.showcaseItem img {\n  background-position: center center;\n  overflow: hidden;\n  border-radius: 25px;\n}\n\n.showcaseText {\n  height:100%;\n  width: 45vw;\n  padding: 5px;\n  display:flex;\n  margin: 10px;\n  font-size: 20pt;\n  text-align: center;\n  justify-content: center;\n}\n\nhr {\n  border: 1px solid #000;\n  width:80vw;\n  margin:10vh\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
